module.exports = __webpack_public_path__ + "static/media/Rainfall_Nervous_Anxiety.e1ec3978.gif";